export const isNullOrUndefined = value => {
  return value === null || value === undefined;
};
//# sourceMappingURL=index.js.map